import * as React from "react";
import {observer} from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Timeline, TimelineStage } from "../timeline";
import { OrderStatusBackground } from "../elements/order.status";
import { FaCheckCircle, FaBan } from "react-icons/fa";

interface Props extends WithTranslation {
  status: OrderStatuses;
  isDelivery?: boolean;
  isBooking?: boolean;
}
interface Injected extends Props {}
interface State {}

@observer
class OrderTimelineClass extends React.Component<Props, State> {

  render() {
    const { t, status, isDelivery, isBooking } = this.props as Injected;

    if (status === "cancelled" || status === "complete") {
      return (
        <OrderStatusBackground
          status={status}
          className="p-tb-3 p-lr-5 text-center flex-center">
          <h4>
            {status === "complete" && <FaCheckCircle className="m-r-2"/>}
            {status !== "complete" && <FaBan className="m-r-2"/>}
          </h4>
          <h4>{t(`order.status.${status}`)}</h4>
        </OrderStatusBackground>
      );
    }

    const stages: TimelineStage[] = [
      { id: "unconfirmed", label: t("order.status.unconfirmed") },
      { id: "confirmed", label: t("order.status.confirmed") },
      { id: "ready", label: t("order.status.ready") },
      { id: "on_route", label: t("order.status.on_route") },
    ];

    if (isBooking) {
      stages.splice(stages.length - 1, 1); // REMOVE ON ROUTE
      stages.splice(stages.length - 1, 1); // REMOVE READY
    }
    else if (!isDelivery) {
      stages.splice(stages.length - 1, 1);
    }

    return (
      <Timeline
        stages={stages}
        current={status}
      />
    );

  }

}

export const OrderTimeline = withTranslation()(OrderTimelineClass);
